
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/editorSearch/views/EmptyState/EmptyState.scss.css.virtualfile';
        module.exports = {"footer":"_footer_oe3rm_1","footerLink":"_footerLink_oe3rm_8"};